import React from "react";
import { Form, Icon, Input, Button, message } from "antd";
import { FormComponentProps } from "antd/es/form";
import Header from "components/Header";
import Style from "./changepwd.module.scss";
import { errorMessage, getTeacherInfo, isTrue } from "service/service";
import useRequestFn from "utils/useRequestFn";
import { ResultMessage } from "components/ResultMessage";
import useRequest from "utils/useRequest";
import { updatePassword } from "service/auth";
import { useAtomValue } from "jotai";
import { loginModeAtom } from "../../../service/stores/SettingsStore";

interface IPageChangePwdProps extends FormComponentProps {}

const PageChangePwd = (props: IPageChangePwdProps) => {
    const { getFieldDecorator } = props.form;
    const loginMode = useAtomValue(loginModeAtom);
    const [teacherInfo] = useRequest(() => getTeacherInfo());
    const [update, { loading }] = useRequestFn(updatePassword);

    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        return props.form.validateFields(async (err, values) => {
            if (err) return;
            try {
                await update(
                    teacherInfo?.teacherno || "",
                    values.oldPassword,
                    values.newPassword
                );
                message.success("修改成功，请重新登录！", 2, () => {
                    window.location.href = "/login";
                });
            } catch (e) {
                ResultMessage.error(errorMessage(e));
            }
        });
    };

    const compareToFirstPassword = (rule: any, value: any, callback: any) => {
        const { form } = props;
        if (value && value !== form.getFieldValue("newPassword")) {
            callback("两次密码输入不一致！");
        } else {
            callback();
        }
    };

    if (!isTrue(loginMode.normalAuthLogin))
        return <div>当前未开启普通登录的修改密码功能</div>;

    return (
        <div>
            <Header />
            <div>
                <div className={Style.form}>
                    <h1>修改密码</h1>
                    <Form className="login-form" onSubmit={handleSubmit}>
                        <Form.Item>
                            {getFieldDecorator("oldPassword", {
                                rules: [
                                    { required: true, message: "请输入原密码!" }
                                ]
                            })(
                                <Input.Password
                                    size="large"
                                    prefix={
                                        <Icon
                                            type="lock"
                                            style={{ color: "rgba(0,0,0,.25)" }}
                                        />
                                    }
                                    placeholder="请输入原密码"
                                />
                            )}
                        </Form.Item>
                        <Form.Item>
                            {getFieldDecorator("newPassword", {
                                rules: [
                                    { required: true, message: "请输入新密码!" }
                                ]
                            })(
                                <Input.Password
                                    size="large"
                                    prefix={
                                        <Icon
                                            type="lock"
                                            style={{ color: "rgba(0,0,0,.25)" }}
                                        />
                                    }
                                    placeholder="请输入新密码"
                                />
                            )}
                        </Form.Item>
                        <Form.Item>
                            {getFieldDecorator("renewPassword", {
                                rules: [
                                    {
                                        required: true,
                                        message: "请确认新密码!"
                                    },
                                    { validator: compareToFirstPassword }
                                ]
                            })(
                                <Input.Password
                                    size="large"
                                    prefix={
                                        <Icon
                                            type="lock"
                                            style={{ color: "rgba(0,0,0,.25)" }}
                                        />
                                    }
                                    placeholder="请再次输入新密码"
                                />
                            )}
                        </Form.Item>
                        <Form.Item>
                            <Button
                                type="primary"
                                size="large"
                                htmlType="submit"
                                block
                                className={Style.loginBtn}
                                loading={loading}>
                                修改
                            </Button>
                        </Form.Item>
                    </Form>
                </div>
            </div>
        </div>
    );
};
export default Form.create<IPageChangePwdProps>({ name: "normal_login" })(
    PageChangePwd
);
